<script setup lang="ts">
import { computed } from 'vue'

import type { SubParticipant } from '@collector/sportsapi-types'

import type { LineupConfig } from '../../interfaces/LineupConfig'
import type { LineupModel } from '../../interfaces/LineupModel'
import AddPlayer from './AddPlayer/AddPlayer.vue'
import PositionSection from './Section/PositionSection/PositionSection.vue'
import SeasonSquadSection from './Section/SeasonSquadSection/SeasonSquadSection.vue'

type Props = {
  config: LineupConfig
  squad?: SubParticipant[]
}
const props = withDefaults(defineProps<Props>(), {
  squad: () => [],
})

// state
const lineup = defineModel<LineupModel>({ required: true })

// computed
const positionsToMerged = computed(() => {
  const result: { [x: PropertyKey]: PropertyKey[] } = {}
  const entries = Object.entries(props.config.positions)
  entries.forEach(([key, config]) => {
    if (!config.mergeWith) result[key] = []
  })
  entries.forEach(([key, config]) => {
    if (config.mergeWith && result[config.mergeWith])
      result[config.mergeWith].push(key)
  })

  return Object.entries(result)
})
</script>

<template>
  <div class="grid w-full gap-2">
    <AddPlayer
      v-model="lineup"
      :config
    />
    <div class="grid h-116 grid-cols-2 items-start gap-2">
      <div class="grid max-h-116 items-start gap-4 overflow-auto">
        <SeasonSquadSection
          v-model="lineup"
          :config
          :squad
        />
      </div>
      <div class="grid max-h-116 items-start gap-4 overflow-auto">
        <PositionSection
          v-for="entry in positionsToMerged"
          :key="entry[0]"
          v-model="lineup"
          :config
          :positionKey="entry[0]"
          :positionKeysMerged="entry[1]"
        />
      </div>
    </div>
  </div>
</template>
